import { gql } from '@apollo/client'

const SEARCH_LEAD_STAGES = gql`
  query SEARCH_LEAD_STAGES($searchTerm: String) {
    searchLeadStages(searchTerm: $searchTerm) {
      id
      name
      totalLeads
      color
      order
      requireReject
      view {
        id
        name
      }
    }
  }
`

export default SEARCH_LEAD_STAGES
